<div class="{{ backgroundColor }} {{ padding }} {{ margin }} shadow-1 border-round">
  <div
    class=" text-{{ align }} flex flex-column md:block"
    [ngClass]="{ 'm-0 p-0': !title || !section, 'mb-3': title || section }"
  >
    <span class="text-xl text-primary font-bold"> {{ section }}</span>
    <span
      class="text-xl font-medium"
      [ngClass]="{
        'text-primary': !section,
        'text-color-secondary lg:ml-1': !!section
      }"
    >
      {{ title }}</span
    >
  </div>

  <ng-content></ng-content>
</div>
